export default __webpack_public_path__ + "static/media/confirm.3680606e.svg";